import LightIcon from './component'

export default LightIcon
